/* tslint:disable */
/* eslint-disable */
/**
 * Solaris User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetHealth200Response
 */
export interface GetHealth200Response {
    /**
     * Health status
     * @type {string}
     * @memberof GetHealth200Response
     */
    'status': GetHealth200ResponseStatusEnum;
    /**
     * Service version
     * @type {string}
     * @memberof GetHealth200Response
     */
    'version'?: string;
    /**
     * Current timestamp
     * @type {string}
     * @memberof GetHealth200Response
     */
    'timestamp': string;
}

export const GetHealth200ResponseStatusEnum = {
    ok: 'ok'
} as const;

export type GetHealth200ResponseStatusEnum = typeof GetHealth200ResponseStatusEnum[keyof typeof GetHealth200ResponseStatusEnum];


